<a id="csv-donwload"></a>

<p-panel
  header="検索"
  [toggleable]="true"
  [collapsed]="false">
  <div class="grid">
    <div class="col-6">
      <div class="custom-iconfield">
        <i class="pi pi-search"></i>
        <textarea
          pInputTextarea
          [(ngModel)]="searchText"
          class="input-full"
          placeholder="JANでコジマの商品を登録する"></textarea>
      </div>
    </div>

    <div class="col-6">
      <p-button
        label="登録待ちに追加"
        styleClass="p-button-info"
        (click)="doRegister()"
        [disabled]="!canRegister()"></p-button>
      <i
        class="pi pi-info-circle"
        pTooltip="{{ queueItems.length }} 件待ち"
        tooltipPosition="right"></i>
      @if (!canRegisterNewItems) {
        <div style="color: red">
          ※ 一週間に登録可能な商品数の上限を超過しました。しばらく時間を空けて改めて登録してください。
        </div>
      }
    </div>

    <div class="col-6">
      <div class="flex align-items-center gap-1">
        <p-checkbox
          [(ngModel)]="showZeroStock"
          inputId="showZeroStock"
          [binary]="true"></p-checkbox>
        <label for="showZeroStock">在庫がない商品を表示する</label>
      </div>
    </div>

    <div class="col-12">
      <label for="ms-groupedArea">エリアでの絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedArea"
          [group]="true"
          [(ngModel)]="selectedArea"
          (onChange)="doChangeArea($event)"
          placeholder="表示したいエリアを選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearArea()"
          pTooltip="選択解除"
          [disabled]="selectedArea.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedPref">都道府県での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedPref"
          [group]="true"
          [(ngModel)]="selectedPref"
          (onChange)="doChangePref($event)"
          placeholder="表示したい都道府県を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearPref()"
          pTooltip="選択解除"
          [disabled]="selectedPref.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <label for="ms-groupedStores">店舗での絞り込み</label>
      <div class="card p-label flex align-items-center gap-2">
        <p-multiselect
          [options]="groupedStores"
          [group]="true"
          [(ngModel)]="selectedStores"
          (onChange)="doChangeStores($event)"
          placeholder="表示したい店舗を選択してください"
          display="chip">
          <ng-template
            let-group
            #group>
            <div class="flex align-items-center">
              <span>{{ group.label }}</span>
            </div>
          </ng-template>
        </p-multiselect>
        <button
          pButton
          iconOnly
          type="button"
          class="p-button-outlined p-button-sm p-button-secondary"
          (click)="clearStores()"
          pTooltip="選択解除"
          [disabled]="selectedStores.length === 0">
          <i
            class="pi pi-times"
            aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="col-12">
      <p-button
        styleClass="p-button-info"
        label="検索"
        icon="pi pi-search"
        (onClick)="doSearch()"></p-button>
    </div>
    <div class="col-12">
      <button
        pButton
        class="p-button-outlined"
        (click)="presetDialog.open()">
        <i
          class="pi pi-bookmark"
          aria-hidden="true"></i>
        お気に入り
      </button>
    </div>
  </div>
</p-panel>
<app-store-preset-dialog
  #presetDialog
  componentName="kojima"
  [currentSelection]="{ selectedArea: selectedArea, selectedPref: selectedPref, selectedStores: selectedStores }"
  (presetLoaded)="onPresetLoaded($event)"></app-store-preset-dialog>
<div class="table-header-sticky-outer">
  全{{ filteredProductsCount.toLocaleString() }}件
  <p-table
    #bicTable
    showGridlines
    [value]="filteredProducts"
    columnResizeMode="expand"
    [tableStyle]="{ 'min-width': '50rem' }"
    class="table-header-sticky"
    sortMode="multiple"
    [paginator]="true"
    [rows]="50"
    [globalFilterFields]="['jan', 'asin', 'name']">
    <ng-template #caption>
      <div class="table-caption">
        <div class="grid">
          <div class="col-3">
            <div class="p-d-flex">
              <button
                type="button"
                pButton
                iconOnly
                pRipple
                (click)="downloadCsv(bicTable)"
                class="p-mr-2"
                pTooltip="CSV"
                tooltipPosition="bottom">
                <i
                  class="pi pi-download"
                  aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-5"></div>
          <div class="col-3">
            <span class="p-input-icon-left ml-auto input-full">
              <input
                pInputText
                class="input-full"
                type="text"
                (input)="bicTable.filterGlobal($event.target.value, 'contains')"
                placeholder="検索キーワード" />
            </span>
          </div>
          <div class="col-1">
            <button
              pButton
              class="p-button-outlined"
              (click)="bicTable.clear()">
              <i
                class="pi pi-filter-slash"
                aria-hidden="true"></i>
              Clear
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th width="6%">画像</th>
        <th width="10%">Keepaグラフ</th>
        <th width="8%">JAN</th>
        <th width="8%">ASIN</th>
        <th
          width="5%"
          pSortableColumn="price">
          価格
          <p-sorticon field="price"></p-sorticon>
        </th>
        <th width="20%">商品名</th>
        <th width="35%">在庫状況</th>
        <th width="8%">登録者</th>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-kojimaProduct>
      <tr class="{{ getRowStyle(kojimaProduct) }}">
        <td>
          <a
            [href]="'https://www.amazon.co.jp/dp/' + kojimaProduct.asin"
            target="_blank">
            <img
              [src]="kojimaProduct.imageUrl"
              style="width: 50px" />
          </a>
        </td>
        <td>
          <app-keepa-graph [asin]="kojimaProduct.asin"></app-keepa-graph>
        </td>
        <td>
          {{ kojimaProduct.jan }}
          <br />
          登録日: {{ kojimaProduct.createdAt | date: 'yyyy/MM/dd' }}
          <br />
          更新日: {{ kojimaProduct.lastCheckedAt | date: 'yyyy/MM/dd' }}
          <br />
          総在庫数: {{ kojimaProduct.totalStockNum }}
          @if (kojimaProduct.boughtPastMonth != null) {
            <br />
            先月販売数: {{ kojimaProduct.boughtPastMonth < 10 ? '9以下' : kojimaProduct.boughtPastMonth }}
          }
        </td>
        <td>
          {{ kojimaProduct.asin }}
          <br />
          ({{ kojimaProduct.amazonPrice | number }})
        </td>
        <td>
          {{ kojimaProduct.price.toLocaleString() }}
          @if (kojimaProduct.anotherPrice) {
            <div>({{ kojimaProduct.anotherPrice && kojimaProduct.anotherPrice.toLocaleString() }})</div>
          }
          <i
            class="pi pi-user-edit clickable"
            style="font-size: 1rem"
            (click)="openAnotherPrice(kojimaProduct)"></i>
        </td>
        <td>
          <a
            [href]="'https://www.amazon.co.jp/dp/' + kojimaProduct.asin"
            target="_blank">
            {{ kojimaProduct.name }}
          </a>
          <br />
          （
          <a
            href="https://www.kojima.net/ec/prod_detail.html?prod={{ kojimaProduct.jan }}&sku={{ kojimaProduct.jan }}"
            target="_blank">
            コジマ
          </a>
          ）（
          <a
            target="_blank"
            href="https://www.kojima.net/ec/shop_stock.html?prod={{ kojimaProduct.jan }}&sku={{ kojimaProduct.jan }}">
            在庫確認
          </a>
          ）
        </td>
        <td>
          <app-store-stock [stocks]="kojimaProduct.filteredStocks"></app-store-stock>
        </td>
        <td>
          <div>{{ kojimaProduct.userName }}</div>
          <div>
            <i
              class="pi pi-trash clickable"
              style="color: red"
              (click)="doDelete(kojimaProduct)"></i>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="価格を登録"
  [(visible)]="showAnotherPriceModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <div class="grid">
    <div class="col-10">
      <input
        type="number"
        class="p-inputtext"
        style="width: 100%"
        pInputText
        [(ngModel)]="anotherPriceModel.price"
        placeholder="価格を入力" />
    </div>
    <div class="col-2">
      <p-button
        label="登録"
        [disabled]="!anotherPriceModel.price"
        (onClick)="doRegisterAnotherPrice()"></p-button>
    </div>
  </div>
</p-dialog>
